import styled from "styled-components"

export const DashBoardWrapper = styled.div`
    .admin_dashboard_statistical {
        width: 100%;
        display: flex;
        justify-content: space-between;
        list-style: none;
        padding: 0;
        margin: 0;
        &_col {
            width: 25%;
            padding: 22px;
            div {
                border: 1px solid #e9e9e9;
                box-shadow: 1px 2px 5px rgba(1, 1, 1, 25%);
                border-radius: 8px;
                padding: 12px;
                display: flex;
                i {
                    font-size: 2.2rem;
                    min-width: 80px;
                    height: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 50%;
                    color: #fff;
                }
               
                div {
                    border: none;
                    box-shadow: none;
                    border-radius: none;
                    display: block;
                    width: 100%;
                    margin-left: 12px;
                    h4{
                        font-size: 1.0rem;
                        font-weight: 500;
                    }
                    p{
                        margin: 0;
                        font-size: 1.4rem;
                        font-weight: 500;
                    }
                }
            }
        }
    }
    .admin_dashboard_chart{
        display: flex;
        align-items: center;
        &_line{
            width: 60%;
        }
        &_doughnut{
            width: 40%;
            padding: 52px;
            display: flex;
            justify-content: center;
        }
    }

`
